import { apiClient } from "./client";

export interface HangfireUrlResponse {
    url: string;
}

/**
 * Gets the Hangfire dashboard URL with access token.
 * Only accessible to SuperAdmin and RiksAdmin roles.
 */
export const getHangfireUrl = async (): Promise<string> => {
    const response = await apiClient.get<HangfireUrlResponse>("/hangfire/url");
    return response.data.url;
};